module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjA4MzMgMjMuMzc2M0wxMS44MzMzIDIxLjU4NDZMMTguODMzMyAyOC41ODQ2TDE4LjgzMzMgNi42Njc5N0wyMS4zMzMzIDYuNjY3OTdMMjEuMzMzMyAyOC41ODQ2TDI4LjM3NSAyMS41NDNMMzAuMTI1IDIzLjMzNDZMMjAuMDgzMyAzMy4zNzYzTDEwLjA4MzMgMjMuMzc2M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/arrow.svg
// module id = ./assets/assistant/arrow.svg
// module chunks = 10